import React, { useEffect, useRef } from "react";
import apiService from "../../APIService";
import cometdLib from "cometd";
import OutsideClickHandler from "react-outside-click-handler";
import { Constants } from "../../../Constants/Constants";
import { useState } from "react";
import backtopmenu from "../../../images/img/backtopmenu-arrow.svg";
import SendIcon from "../../../images/icons/send.svg";
import AgentLoader from "../Utils/AgentLoader";

import AgentConversation from "../AgentConversation/AgentConversation";
import agentIcon from "../../../images/img/generic-human.svg";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import secureLocalStorage from "react-secure-storage";
//cometd configuration start
let cometd = new cometdLib.CometD();
cometd.websocketEnabled = false;
cometd.unregisterTransport("websocket");
var TimeStampExtension = require("cometd/TimeStampExtension");
cometd.registerExtension("timestamp", new TimeStampExtension());
//variables start

var secureKey = "";
var intLastTranscriptPosition = 0;
var cometdConnected = false;
var refreshAdded = false;

var tempUnfiedMessages = [];

var chatReferenceId = "";
var agentId = "";
var agentName = "";
var enablelitmus = false;
var sessionID = "";
var intereactionId = null;
var refreshListener = null;
var publishListener = null;
var disconnectListener = null;
var connectListener = null;
var userInitiatedhandhsake = false;

// var inConversationPage = true;
// var connectedWithAgent = false;
//variables end
cometd.configure({
  url: Constants.TSAgentServerUrl,
});
//test code - start

function fPublish(response) {
  console.log("fPublish", response);

  if (response.successful === false) {
    console.log("Could not publish to channel. <br/>" + response.error);
  } else {
    console.log("Chat session started", response);
    // setAgentLoader(false);
  }
}
function fConnect(response) {
  console.log("genesys-log : response fconnect", response);
}

publishListener = cometd.addListener("/meta/publish", fPublish);
connectListener = cometd.addListener("/meta/connect", fConnect);

const MessageA80 = (props) => {
  const customerData = props?.item?.text_data;

  //todo

  const [qMessages, setQMessages] = useState([
    { text: "A chat expert will be with you shortly." },
  ]);

  const [agentMessages, setAgentMessages] = useState([]);
  const [moveToAgentConversation, setMoveToAgentConversation] = useState(false);
  const [typingIndicator, setTypingIndicator] = useState(false);
  const [show, setShow] = useState(true);
  const [unifiedMessages, setunifiedMessages] = useState([
    {
      index: 0,
      from: {
        type: "Agent",
      },
      type: "Message",
      text: `Welcome to Tata Play,  ${customerData.nickname} We are here to help you, please type in your query in the chat box and click on the send button. Please note that this chat may be recorded and used for quality assurance and training purpose.`,
      seen: false,
    },
  ]);
  const [sendbuttonClicked, setSendbuttonClicked] = useState(false);
  const [scrollTrigger, setScrollTrigegr] = useState(0);

  const prevState = useRef(null);
  // useEffect(() => {
  //   if (agentMessages.length > 1) {
  //     props.setAgentScreenFunction({
  //       agentScreen: true,
  //       agentConnected: true,
  //     });
  //     setMoveToAgentConversation(true);
  //   }
  // }, [agentMessages]);
  const disconnectOnDormancy = () => {
    cometd.disconnect();
    refreshAdded = false;
    cometdConnected = false;
    refreshListener !== null && cometd.removeListener(refreshListener);
    disconnectListener !== null && cometd.removeListener(disconnectListener);
  };
  const keyboardDetect = () => {};
  useEffect(() => {
    console.log(
      "PLOG: IN USEEFECT 1 - SETTING VIEWPORT RESIZE AND CLICK HANLER AND ENABLE LITMUS"
    );
    enablelitmus = customerData?.litmusApiCallEnabled;
    sessionID = customerData?.sessionId;
    secureLocalStorage.setItem("sessionID",sessionID)
    //TODO-INTER :  TAKE INTEREACTIONID AND STORE
    visualViewport.addEventListener("resize", (event) => {
      const h = event.target.height;
      console.log(h, "CHANGED HEIGHT");
      keyboardDetect();
    });
    sendClickHandler();
    console.log(customerData, "PLOG: LITMUS ENABLED");
  }, []);

  useEffect(() => {
    console.log("PLOG: IN USEEFFECT 2 SETTING DATA FOR AGENT", customerData);
    props.setUserDataForAgent(customerData);
    localStorage.setItem(
      "litmusApiCallEnabled",
      customerData.litmusApiCallEnabled
    );
  }, []);

  useEffect(() => {
    if (!show) {
      console.log("PLOG: IN EXPERIMENTAL FEATURE FOR CLEANUP ON SETSHOW FALSE");
      if (cometdConnected && secureKey !== "") {
        let dataForAgentLogs = {
          message: "SENDING DISCONNECT TO AGENT",
          sessionID: sessionID,
          data: "N/A",
          type: "CLIENTS360",
          secureKey: secureKey,
          timeStramp: new Date().getTime(),
        };

        apiService.storeAgentLogs(dataForAgentLogs);
        disconnectTOAgent();
      }
      cleanupA80();
      refreshListener = null;
      publishListener = null;
      disconnectListener = null;
      connectListener = null;
    }
  }, [show]);

  useEffect(() => {
    window.addEventListener("click", () => {
      if (
        localStorage.getItem("onClickedYes").toString() === "true" &&
        cometdConnected &&
        secureKey !== ""
      ) {
        let dataForAgentLogs = {
          message: "SENDING DISCONNECT TO AGENT",
          sessionID: sessionID,
          data: "N/A",
          type: "CLIENTS360",
          secureKey: secureKey,
          timeStramp: new Date().getTime(),
        };
        disconnectTOAgent();

        apiService.storeAgentLogs(dataForAgentLogs);
      }
    });
  }, []);
  const disconnectTOAgent = () => {
    let dataToBePublished = {
      operation: "disconnect",
      secureKey: secureKey,
    };
    cometd.publish(Constants.TSAgentChatChannel, dataToBePublished);
  };
  const cleanupA80 = () => {
    console.log("PLOG: IN CLEANUP");
    refreshListener !== null && cometd.removeListener(refreshListener);
    publishListener !== null && cometd.removeListener(publishListener);
    disconnectListener !== null && cometd.removeListener(disconnectListener);
    connectListener !== null && cometd.removeListener(connectListener);

    cometd.disconnect();
    localStorage.setItem("agentDisconnected", true);

    secureKey = "";
    tempUnfiedMessages = [
      {
        index: 0,
        from: {
          type: "Agent",
        },
        type: "Message",
        text: `Welcome to Tata Play,  ${customerData.nickname} We are here to help you, please type in your query in the chat box and click on the send button. Please note that this chat may be recorded and used for quality assurance and training purpose.`,
        seen: false,
      },
    ];
    intLastTranscriptPosition = 0;
    cometdConnected = false;

    if (document.getElementById("s360-agent-container")) {
      document.getElementById("s360-agent-container").style.display = "none";
    }

    props.setAgentScreenFunction({
      agentScreen: false,
      refresher: Math.random(),
    });
    visualViewport.removeEventListener("resize", keyboardDetect());
    window.removeEventListener("touchend", sendClickHandler);
    console.log("PLOG: DONE CLEARING VARIABLES");

    console.log("PLOG: SET SHOW DONE");
    refreshAdded = false;
  };
  useEffect(() => {
    console.log(
      "PLOG: IN USEEFECT 3 - SETTING AGENT NAME AND SCREEN TO PROPS "
    );
    props.setAgentScreenFunction({
      agentScreen: true,
      name: "Help Assistant",
      refresher: Math.random(),
    });
    localStorage.setItem("agentDisconnected", true);
    return () => {
      if (secureKey !== "") {
        let dataForAgentLogs = {
          message: "SENDING DISCONNECT TO AGENT",
          sessionID: sessionID,
          data: "N/A",
          type: "CLIENTS360",
          secureKey: secureKey,
          timeStramp: new Date().getTime(),
        };
        dataForAgentLogs.sessionId = sessionID;
        apiService.storeAgentLogs(dataForAgentLogs);

        disconnectTOAgent();
      }
      console.log("PLOG: RUNNING CLEANUP FROM A80");
      cometd.disconnect();
      cleanupA80();
      refreshListener = null;
      publishListener = null;
      disconnectListener = null;
      connectListener = null;
      setShow(false);

      console.log(
        "PLOG: VARIABLES AFTER CLEANUP ARE:",
        "secureKey",
        secureKey,
        "intLastTranscriptPosition",
        intLastTranscriptPosition,
        "cometdConnected",
        cometdConnected,
        "refreshAdded",
        refreshAdded,
        "tempUnfiedMessages",
        tempUnfiedMessages,
        "chatReferenceId",
        chatReferenceId,
        "agentId",
        agentId,
        "agentName",
        agentName,
        "show",
        show
      );
    };
  }, []);

  let textData =
    props.item && props.item.text_data && JSON.stringify(props.item.text_data);
  const code = props.item && props.item.code;

  const addUnifiedMessages = (newMessage) => {
    console.log("TLOG:AGENT MESSAGE GETTING ADDED", newMessage);

    if (newMessage.from.type === "External") {
      agentName = "Tata Play";
      localStorage.setItem("prevAgentName", agentName);
      props.setAgentScreenFunction({
        agentScreen: true,
        name: agentName,
        refresher: Math.random(),
      });
    }

    // tempUnfiedMessages.push(newMessage);
    if (newMessage.text.includes("###")) {
      agentId = newMessage.text.match(/^[^#]+/)[0];
      localStorage.setItem("agentId", agentId);
      newMessage.text = /###(.+)/.exec(newMessage.text)[1];
      //CODE TO REMOVE ###ABCDEFGHI FROM ###ABCDEFGHI, HELLO IAM....
    }
    if (newMessage.text.includes("chat reference id is")) {
      let splitMessage = newMessage.text.split(" ");
      intereactionId = splitMessage[splitMessage.length - 1];
      localStorage.setItem("intereactionId", intereactionId);
    }
    newMessage.time = new Date().toLocaleString();

    tempUnfiedMessages = [...tempUnfiedMessages, newMessage];
    tempUnfiedMessages = tempUnfiedMessages.filter(
      (v, i, a) =>
        a.findIndex((v2) => v2.utcTime === v.utcTime && v2.text === v.text) ===
        i
    );
    setunifiedMessages(tempUnfiedMessages);
    console.log("TLOG:ADDED MESSAGES AGENT", tempUnfiedMessages);

    if (tempUnfiedMessages.length > 2 && newMessage.from.type === "Agent") {
      //skipping read recipts for dormancy and queue messages
      localStorage.setItem("agentDisconnected", false);
      let dataToBePublished = {
        operation: "readReceipt",
        secureKey: localStorage.getItem("sky") || secureKey,
        transcriptPosition: newMessage.index,
      };
      cometd.publish(Constants.TSAgentChatChannel, dataToBePublished);
    }

    // if (newMessage.text === Constants.dormancyMessage) {
    //   disconnectOnDormancy();
    // }
  };
  // const addAgentMessagesIntoArray = (newMessage) => {
  //   // if (!connectedWithAgent) {

  //   connectedWithAgent = true;

  //   //   setAgentInfo({ name: newMessage?.from?.nickname });
  //   // }

  //   if (newMessage?.from?.nickname !== "system")
  //     agentName = newMessage?.from?.nickname;

  //   if (
  //     localStorage.getItem("prevAgentName") !== undefined &&
  //     localStorage.getItem("prevAgentName") !== null &&
  //     agentName !== localStorage.getItem("prevAgentName") &&
  //     agentMessageCounter > 0
  //   ) {
  //     props.setAgentScreenFunction({
  //       agentScreen: true,
  //       agentConnected: true,
  //       name: agentName,
  //     });
  //   }
  //   localStorage.setItem("prevAgentName", agentName);
  //   console.log("NEW MESSAGE ", newMessage);
  //   switch (newMessage.type) {
  //     case "Message":
  //       addAgentArrays(newMessage);
  //       break;
  //     case "TypingStarted":
  //       setTypingIndicator(true);

  //       break;
  //     case "TypingStopped":
  //       setTypingIndicator(false);
  //       break;
  //     case "ParticipantLeft":
  //       setTypingIndicator(false);

  //       break;

  //     // case "read-confirm":
  //     //   addReadConfirmToCustomerMessage();
  //     //   break;
  //     default:
  //       break;
  //   }
  // };

  const addunifiedMessagesIntoArray = (newMessage) => {
    // if (!connectedWithAgent) {

    //   setAgentInfo({ name: newMessage?.from?.nickname });
    // }

    if (newMessage?.from?.nickname !== "TIRD") {
      if (newMessage?.from?.nickname === "system") agentName = "TataPlay";
      else {
        agentName = newMessage?.from?.nickname;
      }
    }

    if (newMessage.type === "Message" && newMessage.text !== "") {
      if (newMessage?.from?.nickname === "TIRD") {
        chatReferenceId = newMessage.text;
      }
    }
    props.setAgentScreenFunction({
      agentScreen: true,

      name: agentName,
      refresher: Math.random(),
    });

    localStorage.setItem("prevAgentName", agentName);
    console.log("NEW MESSAGE ", newMessage);
    switch (newMessage.type) {
      case "Message":
        // addAgentArrays(newMessage);
        addUnifiedMessages(newMessage);
        break;
      case "TypingStarted":
        setTypingIndicator(true);

        break;
      case "TypingStopped":
        setTypingIndicator(false);
        break;
      case "ParticipantLeft":
        setTypingIndicator(false);

        break;
      case "ParticipantJoined":
        if (newMessage.from.type === "Agent") {
          newMessage.time = new Date().toLocaleString();
          newMessage.text = `You will be now assisted with ${newMessage.from.nickname} , your chat reference id is ${chatReferenceId}`;
          newMessage.from.type = "External";
          addUnifiedMessages(newMessage);
        }
      // case "read-confirm":
      //   addReadConfirmToCustomerMessage();
      //   break;
      default:
        break;
    }
  };
  const disconnnectAndCloseAgentScreen = async () => {
    cometd.disconnect();
    cometdConnected = false;
    console.log("PLOG: IN DOSCONNECT AND CLOSE");

    console.log("PLOG: TRYOING LITMUS API", enablelitmus);

    let dataForAgentLogs = {
      message: "SENDING LITMUS TRIGGER",
      sessionID: sessionID,
      data: `LITMUS TRIGGER FLAG ${enablelitmus}`,
      type: "CLIENTS360",
      secureKey: secureKey,
      timeStramp: new Date().getTime(),
    };
    dataForAgentLogs.sessionId = sessionID;
    apiService.storeAgentLogs(dataForAgentLogs);



    enablelitmus &&
      enablelitmus !== false &&
      props.fetchFeedbackUrlApi({ mode: "iFrame", agentName: agentName });
    console.log("PLOG: PROPS.CODE");
    props.handleClick(code);
    setShow(false);

    //TODO : PROPS.DISABLELITMUS
  };
  function fDisconnect(response) {
    console.log("PLOG:in disconnect");
    cometdConnected = false;
    apiService.agentStatus(
      customerData?.userData?.cti_SubscriberID,
      `${
        customerData?.userData?.FirstName +
        customerData?.userData?.LastName.trim()
      }`,
      customerData?.userData?.PhoneNumber,
      localStorage.getItem("sky") || secureKey,
      props.source
    );
    // if (unifiedMessages.length > 1) {
    //   startCometdChat();
    // }
  }
  function refresh(response) {
    localStorage.setItem("disconnectInA80", false);

    if (response.data.chatEnded) {
      console.log(
        "PLOG: RUNNING AGENTDISCONNCTED AD CHAT ENDED BY AGENT FROM A80"
      );
      
      //TODO 1 - PUT DISCONNECTFORAGENT()
      let dataForAgentLogs = {
        message: "SENDING DISCONNECT TO AGENT AS CHAT ENDED RECIEVED ",
        sessionID: sessionID,
        data: response,
        type: "CLIENTS360",
        secureKey: secureKey,
        timeStramp: new Date().getTime(),
      };

      apiService.storeAgentLogs(dataForAgentLogs);
      disconnectTOAgent();
      disconnnectAndCloseAgentScreen();
      return;
    }

    secureKey = response.data.secureKey;
    localStorage.setItem("sky", secureKey);
    //new code for agent messages to be acknowledged.

    if (
      response?.data?.messages[0] !== undefined &&
      response?.data?.messages[0]?.from !== undefined
    ) {
      let messageType = response?.data?.messages[0]?.from?.type;
      let messageData = response?.data?.messages[0];
      console.log(
        "genesys-log : response refresh",
        messageType,
        messageData,
        response.data
      );
      let dataForAgentLogs = {
        message: "MESSAGE RECIEVED IN REFRESH FROM GENESYS",
        sessionID: sessionID,
        data: response.data,
        type: "GENESYS",
        secureKey: secureKey,
        timeStramp: new Date().getTime(),
      };

      apiService.storeAgentLogs(dataForAgentLogs);
      console.log("TLOG:1.RECIEVD MESSAGE OF TYPE", messageType);
      switch (messageType) {
        case "External":
          {
            console.log("TLOG:ADDING QUEUE MESSAGE");
            addunifiedMessagesIntoArray(messageData);
          }

          break;
        case "Agent": {
          console.log("TLOG:ADDING AGENT MESSAGE");
          addunifiedMessagesIntoArray(messageData);
        }
        default:
          break;
      }
    }

    localStorage.setItem("secureKey", response.data.secureKey);
  }

  // cometd.addListener('/meta/handshake', fHandshake);
  // cometd.addListener('/meta/disconnect', fDisconnect);
  if (!refreshAdded) {
    refreshAdded = true;
    console.log("GNLOG: REFRESH LISTENER ADDED");
    refreshListener = cometd.addListener(Constants.TSAgentChatChannel, refresh);
    disconnectListener = cometd.addListener("/meta/disconnect", fDisconnect);
  }

  //request method
  // function request(operation, params) {
  //   if (cometd) {
  //     var data = {
  //       operation: operation,
  //       // secureKey:localStorage.getItem("sky") ||    secureKey,
  //     };
  //     data.params = params;
  //     var finalData = data;
  //     console.log(Constants.TSAgentChatChannel, finalData,"REQUEST NOTIFICATION PAYLOAD")
  //     cometd.publish(Constants.TSAgentChatChannel, finalData);
  //   } else {
  //     console.log("GENESYS-LOG: COMETD NOT CONNECTED");
  //   }
  // }

  // const agentConnectedFunction = () => {
  //   // cometd.disconnect();
  //   setAgentLoader(false);
  //   connectedWithAgent = true;
  // };

  const startCometdChat = () => {
    let dataForAgentLogs = {
      message: "INITIATING HANDSHAKE",
      sessionID: sessionID,
      data: customerData,
      type: "CLIENTS360",
      secureKey: secureKey,
      timeStramp: new Date().getTime(),
    };
    apiService.storeAgentLogs(dataForAgentLogs);
    console.log("PLOG: INITIATING HANDSHAKE", customerData);
    console.log("GENEYS-LOG: 1. HANDSHAKE STARTED");
    cometd.handshake(function (handshakeReply) {
      if (handshakeReply.successful) {
        let tempCustomerData = customerData;
        delete tempCustomerData.litmusApiCallEnabled;
        delete tempCustomerData.sessionId;
        console.log("GENEYS-LOG: 2.HANDHSAKE SUCCESFULL", handshakeReply);
        // props.setAgentScreenFunction();
        props.setLoadingFunction(true);
        if (userInitiatedhandhsake) {
          cometd.publish(
            Constants.TSAgentChatChannel,
            tempCustomerData,
            function (message) {
              if (message.successful) {
                
                let dataForAgentLogs = {
                  message: "PUBLISH SUCCESSFUL FROM GENESYS",
                  sessionID: sessionID,
                  data: message,
                  type: "GENESYS",
                  secureKey: secureKey,
                  timeStramp: new Date().getTime(),
                };
                apiService.storeAgentLogs(dataForAgentLogs);
                console.log("GENEYS-LOG: 3.PUBLISHED SUCCESSFULLY", message);
                userInitiatedhandhsake = false;
                //TODO 2 THIS IS TO STOP MULTIPLE CONNECTIONS
                cometdConnected = true;
                // props.setIsConnectedWithAgentFunction();
                console.log("GENEYS-LOG: 4.CALLING REQUEST", message);
                // request("requestNotifications", {
                //   secureKey:localStorage.getItem("sky") || message.secureKey,
                //   transcriptPosition: intLastTranscriptPosition,
                //   message: "", // get current text in text input
                // });
              } else {
                console.log("GENEYS-LOG: PUBLISH FAILED", message);
                let dataForAgentLogs = {
                  message: "PUBLISH FAILED FROM GENESYS",
                  sessionID: sessionID,
                  data: message,
                  type: "GENESYS",
                  secureKey: secureKey,
                  timeStramp: new Date().getTime(),
                };
                apiService.storeAgentLogs(dataForAgentLogs);
                cometd.disconnect();
                //  agentConnectedFunction()
                //   setAgentInfo({
                //     participantId:5,
                //     nickname:"Seema Prabhuram Choudhary",
                //     type:"Agent"
                //  })
                //  setAgentConnected(true);
              }
            }
          );
        } else {
          console.log(
            "PLOG: INITIATING HANDSHAKE FAILED AS USER DID NOT INITIATE IT",
            customerData
          );
          console.log("GENEYS-LOG: 1. HANDSHAKE FORCEFULLY STOPPED");
          return;
        }
      } else console.log("GENEYS-LOG: HANDHSAKE FAILED.");
    });
    // }

    //
  };
  const setAgentnameInHeader = () => {
    var headerVal = document.getElementsByClassName("chat-avtar-detail bold");

    for (var i = 0; i < headerVal.length; i++) {
      headerVal[i].innerHTML = "Agent test connected";
    }
  };
  // const handleTextBox = (e) => {};

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("PLOG: CLICKED ON ENTER");
      event.preventDefault();
      let value = document.getElementById("txA").value;
      document.getElementById("txA").value = "";
      if (value.trim().length > 0) publishAndAddCustomerMessage(value);

      // testMessagePush(document.getElementById("txA").value);
    }
  };
  const sendClickHandler = () => {
    const btn = document.querySelector("#agent-button");
    if (btn) {
      btn.addEventListener("touchend", (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        //functions for the Button need to be called here
        let value = document.getElementById("txA").value;
        document.getElementById("txA").value = "";
        if (value.trim().length > 0) publishAndAddCustomerMessage(value);
      });
    }
  };
  const handleArrowClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // setSendbuttonClicked(!sendbuttonClicked)
    let value = document.getElementById("txA").value;
    document.getElementById("txA").value = "";
    if (value.trim().length > 0) publishAndAddCustomerMessage(value);
  };
  // const addReadConfirmToCustomerMessage = () => {
  //   const pos = agentMessages
  //     .reverse()
  //     .findIndex((a) => a?.from?.type === "Client");
  //   let tempArray = agentMessages;
  //   tempArray[pos - tempArray.length - 1].seen = true;
  //   setAgentMessages(tempArray);
  // };
  const publishAndAddCustomerMessage = (newMessage) => {
    let dataToBePushed = {
      operation: "sendMessage",
      secureKey: localStorage.getItem("sky") || secureKey,
      text: newMessage,
      time: new Date().toLocaleString(),
      nickname: customerData.nickname,
      from: {
        type: "Client",
      },
      seen: false,
      utcTime: new Date().getTime(),
    };
    let dataToBePublished = {
      operation: "sendMessage",
      secureKey: localStorage.getItem("sky") || secureKey,
      message: newMessage,
      nickname: customerData.nickname,
    };
    let dataForAgentLogs = {
      message: "SENDING MESSAGE FROM S360",
      sessionID: sessionID,
      data: dataToBePublished,
      type: "CLIENTS360",
      secureKey: secureKey,
      timeStramp: new Date().getTime(),
    };

    apiService.storeAgentLogs(dataForAgentLogs);
    console.log(
      "PLOG: EARLIER MESSAGES AND LENGTH",
      tempUnfiedMessages,
      tempUnfiedMessages.length
    );
    if (tempUnfiedMessages.length === 0) {
      console.log("PLOG: ADDING DEFAULT MEESAGE");
      tempUnfiedMessages.push({
        index: 0,
        from: {
          type: "Agent",
        },
        type: "Message",
        text: `Welcome to Tata Play,  ${customerData.nickname} We are here to help you, please type in your query in the chat box and click on the send button. Please note that this chat may be recorded and used for quality assurance and training purpose.`,
        seen: false,
      });
    }
    tempUnfiedMessages = [...tempUnfiedMessages, dataToBePushed];

    //setAgentMessage([...agentMessages,dataToBePushed]);
    setunifiedMessages(tempUnfiedMessages);

    console.log(
      "PLOG: EARLIER MESSAGES AND LENGTH AFTER",
      tempUnfiedMessages,
      tempUnfiedMessages.length
    );
    if (tempUnfiedMessages.length > 2) {
      cometd.publish(Constants.TSAgentChatChannel, dataToBePublished);
    }
    console.log("PLOG: RESETTING INPUT VALUE");
    document.getElementById("txA").value = "";
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     console.log("EXITING");
  //      disconnnectAndCloseAgentScreen();
  //   }, 10000);
  // }, []);

  useEffect(() => {
    console.log(
      "PLOG: IN USEEFECT 4 - TO START GENESYS BASED ON UNIFIEDMESSAGES",
      unifiedMessages[unifiedMessages.length - 1]
    );
    if (!cometdConnected && unifiedMessages.length > 1) {
      if (
        unifiedMessages[unifiedMessages.length - 1]?.from?.type === "Client"
      ) {
        console.log("PLOG: STARTING GENESYS");
        userInitiatedhandhsake = true;
        startCometdChat();
      }
    }
  }, [unifiedMessages]);

  return (
    <div>
      {show ? (
        <div
          id="s360-agent-container"
          className="s360-agent-container-full"
          style={{
            top: document.getElementById("help-card-header").clientHeight,
          }}
        >
          <div className="s360-agent-container-body">
            {/* <div className="s360-agent-switch-tab">
        <div
          className="agentSwitch center-align"
          style={{ width: document.getElementById("top").clientWidth }}
        >
          <button
            onClick={() => {
              document.getElementById(
                "s360-agent-container"
              ).style.display = "none";
              props.setAgentScreenFunction({
                agentConnected: true,
                agentScreen: false,
                name: agentName,
              });
            }}
            className="button"
          >
            <span>
              <img src={backtopmenu} alt="" />
            </span>
            View chat history with TataPlay HelpBot
          </button>
        </div>
      </div> */}

            <div className="s360-agent-conversationContainer">
              <div className="s360-agent-chat-section">
                <AgentConversation
                  scrollTrigger={scrollTrigger}
                  messages={unifiedMessages}
                  typingIndicator={typingIndicator}
                  chatRefID={chatReferenceId}
                  sendbuttonClicked={sendbuttonClicked}
                  customerData={customerData}
                />
              </div>

              <div className="scrollDetector" id="scrollDetector"></div>
              {/* <OutsideClickHandler
            onOutsideClick={() => {
              document.getElementById("top").style.height = "100%";
              setScrollTrigegr(Math.random());
            }}
          > */}
              <div className="s360-agent-input-container">
                {typingIndicator && (
                  <div className="agentTypingIndicatorSection" key={props}>
                    <strong>{`${agentName} typing...`}</strong>
                  </div>
                )}
                <div className="text-area-input-box-container">
                  <textarea
                    onTouchStart={() => setScrollTrigegr(Math.random())}
                    id="txA"
                    maxRows={4}
                    style={{
                      maxHeight: "128px",
                      // opacity: enableDefaultTextBox ? "100%" : "50%",
                    }}
                    // ref={messageRef}
                    className="text-area-input-box"
                    aria-label="empty textarea"
                    placeholder="Type your query..."
                    // onChange={(e) => handleTextBox(e)}
                    onKeyPress={handleKeyPress}
                    onTouchEnd={() => {
                      // document.getElementById("top").style.height = "63vh";

                      setScrollTrigegr(Math.random());
                    }}
                    onFocus={() => {
                      //  document.getElementById("top").style.height = "63%";

                      setScrollTrigegr(Math.random());
                    }}
                    onBlur={() => {
                      // document.getElementById("top").style.height = "100%";
                      setScrollTrigegr(Math.random());
                    }}
                    // disabled={!enableDefaultTextBox}
                  />

                  <button
                    id="agent-button"
                    style={{ all: "unset" }}
                    onClick={(e) => handleArrowClick(e)}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      src={SendIcon}
                      alt={SendIcon}
                      height="20px"
                      width="20px"
                      // onClick={() => handleNewLink()}
                    ></img>
                  </button>
                </div>
              </div>
              {/* </OutsideClickHandler> */}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MessageA80;
